import { c as clearBodyLocks, l as lock, u as unlock } from "./tua-bsl-uIxvG2ZV.js";
class Modal extends HTMLElement {
  constructor() {
    super();
    this.lastFocusedElement = null;
    this.originalParent = null;
    this.originalNextSibling = null;
    this.portal = false;
    this.modal = null;
    this.scrollElement = null;
    this.closeModalButtons = [];
    this.focusableElements = null;
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;
    this.modalName = null;
  }
  connectedCallback() {
    this.getModalName();
    this.cacheDomElements();
    this.setupEventListeners();
    this.checkOpenAttribute();
    this.checkPortalAttribute();
  }
  disconnectedCallback() {
    clearBodyLocks();
  }
  checkOpenAttribute() {
    const open = this.getAttribute("open") === "true";
    if (open) {
      this.showModal();
    }
  }
  checkPortalAttribute() {
    this.portal = this.getAttribute("portal") === "true";
  }
  getModalName() {
    this.modalName = this.getAttribute("modal-name");
    if (!this.modalName) {
      throw new Error("Modal name attribute is required");
    }
  }
  cacheDomElements() {
    this.modal = this;
    if (!this.modal) {
      throw new Error("Modal element not found");
    }
    this.scrollElement = this.querySelector("[js-modal=scrollElement]");
    this.closeModalButtons = Array.from(
      this.querySelectorAll("[data-close-modal]")
    );
  }
  setupEventListeners() {
    this.closeModalButtons.forEach((button) => {
      button.addEventListener("click", () => this.hideModal());
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.hideModal();
      }
    });
    const overlay = this.querySelector(".modal__overlay");
    if (overlay) {
      overlay.addEventListener("click", this.overlayClickHandler.bind(this));
    }
    document.addEventListener(
      `modal:show:${this.modalName}`,
      () => this.showModal()
    );
    document.addEventListener(
      `modal:hide:${this.modalName}`,
      () => this.hideModal()
    );
  }
  overlayClickHandler() {
    if (!this.hasAttribute("persist-dialog")) {
      this.hideModal();
    }
  }
  showModal() {
    this.lastFocusedElement = document.activeElement;
    this.modal.setAttribute("aria-hidden", "false");
    this.classList.add("is-open");
    const header = document.querySelector(
      ".header-background, .header-background-transparent"
    );
    const modalOverlay = this.querySelector(".modal__overlay");
    const isFreshPage = window.location.pathname === "/pages/fresh";
    if (modalOverlay && header && this.modalName === "account-overlay" && isFreshPage && header.classList.contains("header-background-transparent")) {
      modalOverlay.classList.remove(
        "modal__overlay--no-margin",
        "modal__overlay--negative-margin"
      );
      modalOverlay.classList.add("modal__overlay--negative-margin");
    }
    if (this.portal) {
      this.originalParent = this.modal.parentNode;
      this.originalNextSibling = this.modal.nextSibling;
      document.body.appendChild(this.modal);
    }
    this.setupFocusTrap();
    lock(this.scrollElement || this.modal);
    document.dispatchEvent(
      new CustomEvent("modal:show", {
        detail: {
          modalName: this.modalName
        }
      })
    );
  }
  hideModal(restoreFocus = true) {
    clearBodyLocks();
    this.modal.setAttribute("aria-hidden", "true");
    this.classList.remove("is-open");
    const modalOverlay = this.querySelector(".modal__overlay");
    if (modalOverlay) {
      modalOverlay.classList.remove(
        "modal__overlay--no-margin",
        "modal__overlay--negative-margin"
      );
    }
    document.removeEventListener("keydown", this.trapFocus);
    if (this.portal && this.originalParent) {
      if (this.originalNextSibling) {
        this.originalParent.insertBefore(this.modal, this.originalNextSibling);
      } else {
        this.originalParent.appendChild(this.modal);
      }
    }
    if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === "function" && restoreFocus) {
      this.lastFocusedElement.focus();
    }
    unlock(this.modal);
    document.dispatchEvent(new CustomEvent(`modal:closed:${this.modalName}`));
  }
  setupFocusTrap() {
    this.focusableElements = this.modal.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]'
    );
    if (this.focusableElements.length) {
      this.firstFocusableElement = this.focusableElements[0];
      this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
      this.firstFocusableElement.focus();
      document.addEventListener("keydown", this.trapFocus.bind(this));
    }
  }
  trapFocus(event) {
    var _a, _b;
    if (event.key === "Tab") {
      if (event.shiftKey) {
        if (document.activeElement === this.firstFocusableElement) {
          (_a = this.lastFocusableElement) == null ? void 0 : _a.focus();
          event.preventDefault();
        }
      } else if (document.activeElement === this.lastFocusableElement) {
        (_b = this.firstFocusableElement) == null ? void 0 : _b.focus();
        event.preventDefault();
      }
    }
  }
}
export {
  Modal as M
};
